import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ClienteService } from '../../../services/cliente/cliente.service';
import { HttpErrorResponse } from '@angular/common/http';
import { LocalizacionService } from '../../../services/localizacion/localizacion.service';
import { CotizacionService } from '../../../services/cotizacion/cotizacion.service';
import { ProveedorService } from '../../../services/proveedor/proveedor.service';
import { MessageService } from 'primeng/api';
import { ProductoService } from '../../../services/producto/producto.service';
import { CatalogoService } from '../../../services/catalogo/catalogo.service';
import { ConfigService } from '../../../services/config/config.service';
import { ReportesService } from '../../../services/reportes/reportes.service';
import { CurrencyPipe } from '@angular/common';
import { FleteService } from '../../../services/flete/flete.service';

@Component({
  selector: 'app-cotizacion-detallle',
  templateUrl: './cotizacion-detallle.component.html',
  styleUrls: ['./cotizacion-detallle.component.scss'],
  standalone: false,
  providers: [MessageService, CurrencyPipe]
})

export class CotizacionDetallleComponent implements OnInit {
  loadMenu: boolean = true;
  load: boolean = false;
  token: any = {};
  infoUser: any = {};
  empresa: any = {};
  infoParametrizacion: any = {};
  idCotizacion: number | undefined;
  formClient = new FormGroup({
    tipo: new FormControl({ idTipoIdentificacion: 0 }, Validators.required),
    identificacion: new FormControl(null, [Validators.required, Validators.pattern(/^(0|[1-9][0-9]*)$/)]),
    razonSocial: new FormControl('', Validators.required),
    nombres: new FormControl('', [Validators.required, Validators.maxLength(200)]),
    direccion: new FormControl(''),
    departamento: new FormControl(null),
    ciudad: new FormControl(null),
    correo: new FormControl('', [Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/), Validators.required]),
    telefono: new FormControl('', [Validators.pattern(/^(0|[1-9][0-9]*)$/)])
  });
  listDptos: Array<any> = [];
  listCities: Array<any> = [];
  citySelected: any = {};
  cityShippingSelected: any = {};
  listIdentificationType: Array<any> = [];
  digito: number | undefined;
  divInfoClient: boolean = false;
  lsInfoCotizacion: any = {};
  infoShipping: any = {};
  emailShipping: String = "";
  listCategorization: Array<any> = [];
  listProducts: Array<any> = [];
  listProductsFilter: Array<any> = [];
  totales: Array<number> = [0, 0, 0]; //subtotal, impuesto, total

  indexSelectedSKU: number | undefined;
  divShowDeleteSku: boolean = false;
  selectedItem: any = {};
  divShowEndQuotation: boolean = false;
  // commercal policy
  listCommercialPolicy: Array<any> = [];
  selectedCommercialPolicy: any = {};
  showCommercialPolicy: boolean = true;
  // localizador de inventario
  lsInvSkuSelected: Array<any> = [];

  msgTerminationQuotation: string = "";
  urlDownload: string = "";

  displayPrecio: boolean = false;
  displayFlete: boolean = false;
  itemSKU: any = {};
  urlImages: string = "";

  cobroFlete: any = { subtotal: 0, impuesto: 0 };
  shippingValue: number = 0;
  timeoutQ: any = undefined; // time out para que se espere a actualizar la cantidad de productos
  priceDiscountType: number = 1;

  constructor(private route: ActivatedRoute,
    private client: ClienteService,
    private localizacion: LocalizacionService,
    private cotizacion: CotizacionService,
    private router: Router,
    private proveedor: ProveedorService,
    private message: MessageService,
    private producto: ProductoService,
    private catalogo: CatalogoService,
    private config: ConfigService,
    private reporte: ReportesService,
    private currency: CurrencyPipe,
    private flete: FleteService
  ) { }

  ngOnInit(): void {

    this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
    this.infoUser = JSON.parse(localStorage.getItem('infoUser') ?? "[]");
    this.empresa = JSON.parse(localStorage.getItem('empresa') ?? "[]");
    this.infoParametrizacion = JSON.parse(localStorage.getItem('parametros') ?? "");
    // get information of dptos
    this.listDptos = JSON.parse(localStorage.getItem('listDptos') ?? "[]");
    this.urlImages = this.config.urlIMG;


    // get categorizacion de producto
    if (!localStorage.getItem("categorizationList"))
      this.producto.getCategorizacion(this.token.token).subscribe((response) => {
        this.listCategorization = response as Array<any>;
        localStorage.setItem("categorizationList", JSON.stringify(this.listCategorization))

        // get products in general
        if (!localStorage.getItem("listProducts"))
          this.catalogo.getProductosProveedor(this.token.token).subscribe((response) => {
            this.listProducts = response as Array<any>;
            localStorage.setItem("listProducts", JSON.stringify(this.listProducts))
            this.getInfoCotizacion();
          });
      });
    else {
      this.listCategorization = JSON.parse(localStorage.getItem("categorizationList") ?? "[]");
      this.listProducts = JSON.parse(localStorage.getItem("listProducts") ?? "[]");
      this.getInfoCotizacion();
    }

    this.load = true;


    // get comercial policy
    this.proveedor.getPoliticasComerciales(this.token.token).subscribe({
      next: (response) => {
        this.listCommercialPolicy = response as Array<any>;
        if (this.listCommercialPolicy.length == 1)
          this.selectedCommercialPolicy = this.listCommercialPolicy[0];
      },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); }
    })

  }
  /**
   * Obtención de la cotización
   */
  getInfoCotizacion = () => {

    //llevando al inicio
    setTimeout((content: any) => {
      this.config.navegar('divIni', false, -50)
    }, 1000)
    // get identification types
    this.client.getTypeIndetification(this.token.token).subscribe({
      next: (response) => {
        this.listIdentificationType = response as Array<any>;
        this.route.paramMap.subscribe(params => {
          this.idCotizacion = parseInt((params.get('idCotizacion') ?? "0"));
          // get quotation by number
          this.cotizacion.getCotizacionByNumber(this.token.token, this.idCotizacion).subscribe({
            next: (response) => {
              this.load = false;
              this.lsInfoCotizacion = response as any;
              this.infoShipping = this.lsInfoCotizacion.dataShipping.split('||');
              this.formClient.controls.tipo.setValue(this.listIdentificationType.filter(row => row.idTipoIdentificacion == this.lsInfoCotizacion.idClienteNavigation.idTipoIdentificacion)[0]);
              this.formClient.controls.identificacion.setValue(this.lsInfoCotizacion.idClienteNavigation.identificacion);
              this.formClient.controls.nombres.setValue(this.lsInfoCotizacion.idClienteNavigation.nombres);
              this.formClient.controls.razonSocial.setValue(this.lsInfoCotizacion.idClienteNavigation.razonSocial);
              this.formClient.controls.telefono.setValue(this.lsInfoCotizacion.idClienteNavigation.telefono);
              this.formClient.controls.correo.setValue(this.lsInfoCotizacion.idClienteNavigation.email);
              this.formClient.controls.direccion.setValue(this.lsInfoCotizacion.idClienteNavigation.direccion);
              // customer's information
              if ((this.lsInfoCotizacion.idClienteNavigation?.idCiudad ?? 0) > 0)
                this.localizacion.getCitiesId(this.token.token, this.lsInfoCotizacion.idClienteNavigation.idCiudad).subscribe({
                  next: (response1) => {
                    this.citySelected = response1;
                    this.formClient.controls.departamento.setValue((response1 as any).idDepartamentoNavigation);
                    this.loadCities();
                  },
                  error: (error: HttpErrorResponse) => { this.config.handleError(error); }
                });


              // product's info
              this.listProducts.map((row: any) => {
                // eliminación de items de lista de precios no equivalentes al filtro
                row.detalleListaPrecios = row.detalleListaPrecios.filter((item: any) => {
                  return item.idListaPrecios == this.lsInfoCotizacion.idListaPrecios
                })
              });

              // detail 
              this.lsInfoCotizacion.detalle = this.lsInfoCotizacion.estado == 1 ? this.lsInfoCotizacion.detalleCotizacionInicials : this.lsInfoCotizacion.detalleCotizacions;
              console.log(this.lsInfoCotizacion.detalle);
              delete this.lsInfoCotizacion['detalleCotizacionInicials'];
              delete this.lsInfoCotizacion['detalleCotizacions'];

              this.lsInfoCotizacion.detalle.map((row: any) => {
                row.infoProducto = this.listProducts.filter(item => item.idProducto == row.idProducto)[0];

                // categorization
                row.infoProducto.categorizacion = row.infoProducto.categorizacionProducto?.isStrcategorizacionProveedor.split('|')
                  .filter((element: any) => { return element != "" })
                  .map((element: any) => {
                    //get category
                    let category: any = this.listCategorization.filter(item2 => { return item2.idCategorizacionProveedor == element });
                    if (category.length > 0) {
                      return {
                        id: element,
                        nameCategory: category[0]?.descripcion,
                        position: category[0]?.posicion
                      }
                    }
                    else
                      return;
                  });

                // asignación de precios
                row.precioPromocion = this.lsInfoCotizacion.estado == 2 ? (row.subtotal + row.impuesto) / row.cantidad : row.infoProducto.detalleListaPrecios[0].precioPromocion;
                row.precio = this.lsInfoCotizacion.estado == 2 ? (row.subtotal + row.impuesto) / row.cantidad : row.infoProducto.detalleListaPrecios[0].precio;


                delete row.infoProducto['detalleListaPrecios'];

                /// conocer el inventario de cada item
                if (this.lsInfoCotizacion.estado == 1)
                  this.getInventory(row);

              });

              // shipping's information
              if (this.infoShipping[3].trim().replace('undefined', '') != '')
                this.localizacion.getCitiesId(this.token.token, this.infoShipping[3]).subscribe({
                  next: (response2) => {
                    this.cityShippingSelected = response2;
                    this.getTotal();
                  },
                  error: (error: HttpErrorResponse) => { this.config.handleError(error); }
                })
              else
                this.getTotal();

            },
            error: (error: HttpErrorResponse) => { this.config.handleError(error); this.load = false; }
          });
        });
      },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); }
    });
  }

  loadCities = () => {
    this.localizacion.getCities(this.token.token, (this.formClient.controls.departamento.value as any).idDepartamento).subscribe({
      next: (response) => {
        this.listCities = response as Array<any>;
        // there is a selected city
        if (this.citySelected?.idCiudad > 0)
          this.formClient.controls.ciudad.setValue(this.listCities.filter(row => row.idCiudad == this.citySelected?.idCiudad)[0]);
      },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); }
    })
  }

  showDialogItem = (item: any, index: number) => {
    this.indexSelectedSKU = index;
    if (item.cantidad == 0) {
      this.divShowDeleteSku = true;
      item.index = index;
      this.selectedItem = item;
    } else {
      // se procede con la actualización de cantidad
      clearTimeout(this.timeoutQ);

      this.timeoutQ = setTimeout(() => {
        this.updateQSKU(item, this.indexSelectedSKU ?? -1);
        clearTimeout(this.timeoutQ);
      }, 1000);
    }
  }



  reInsertProducts = () => {

    localStorage.setItem('dataShipping', this.lsInfoCotizacion?.dataShipping);
    this.router.navigate(['cotizacion/crear_cotizacion'], {
      fragment: this.lsInfoCotizacion?.idClienteNavigation?.idTipoIdentificacion + "/" +
        this.lsInfoCotizacion?.idClienteNavigation?.identificacion + '/' +
        this.lsInfoCotizacion?.idListaPrecios + "/" + this.lsInfoCotizacion?.idCanalVenta
    });
  }

  //get inventory of sku
  getInventory = (item: any) => {
    this.proveedor.getInventarioTiendas(this.token.token, this.empresa[0].idProveedor, item.infoProducto.idProducto)
      .subscribe({
        next: (response) => {
          item.inventory = response as Array<any>;
          item.inventoryNumber = 0;
          item.inventory.map((field: any) => { item.inventoryNumber = item.inventoryNumber + field.tiendaProductos[0].cantidadEnMano })

        },
        error: (error: HttpErrorResponse) => { this.config.handleError(error); this.divShowDeleteSku = false; }
      });
  }

  //actualizar cantidades  y eliminar productos para el SKU selected
  updateQSKU = (item: any, index: number) => {
    if (item.cantidad == 0)
      this.divShowDeleteSku = false;
    this.load = true;
    const dataSKUQ = {
      idDetalleCotizacionInicial: item.idDetalleCotizacionInicial,
      cantidad: item.cantidad,
      subtotal: Number(((((item.precioPromocion < item.precio ? item.precioPromocion : item.precio)) / (((item.infoProducto.impuesto) / 100) + 1)) * item.cantidad).toFixed(2)),
      impuesto: Number((((item.precioPromocion < item.precio ? item.precioPromocion : item.precio) * item.cantidad)) -
        //subtotal
        ((((item.precioPromocion < item.precio ? item.precioPromocion : item.precio)) / (((item.infoProducto.impuesto) / 100) + 1)) * item.cantidad)).toFixed(2)
    }
    this.cotizacion.updateQSKUCotizacion(this.token.token, dataSKUQ).subscribe({
      next: (response) => {
        if (item.cantidad == 0)
          this.lsInfoCotizacion.detalle.splice(index, 1); this.getTotal(); this.load = false;
      },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); this.load = false; }
    })
  }

  getTotal = () => {
    this.totales[0] = 0;// subtotal
    this.totales[1] = 0;//impuesto
    this.lsInfoCotizacion?.detalle.map((row: any) => {

      this.totales[0] += Number((((row.precioPromocion >
        row.precio ? row.precio : row.precioPromocion) / ((row.infoProducto.impuesto / 100) + 1)) * row.cantidad).toFixed(2));
      this.totales[1] += Number(((row.precioPromocion >
        row.precio ? row.precio : row.precioPromocion) * row.cantidad).toFixed(2)) -
        // subtotal
        Number((((row.precioPromocion >
          row.precio ? row.precio : row.precioPromocion) / ((row.infoProducto.impuesto / 100) + 1)) * row.cantidad).toFixed(2));
    });
    this.getFlete();
  }

  continue = () => {
    if (this.selectedCommercialPolicy?.idPoliticaComercial > 0) {
      this.divShowEndQuotation = true;
      this.emailShipping = this.formClient.controls.correo.value ?? "";
    }
    else
      this.message.add({ severity: 'warning', detail: 'Favor seleccione una política comercial' })
  }

  editQuotation = () => {
    // para editar debe haber sido cerrada y aun no haber sido cancelada
    if (this.lsInfoCotizacion.estado == 2 && !this.lsInfoCotizacion.paymentMade && !this.lsInfoCotizacion.idEstadoSeguimientoCotizacionNavigation?.readyForImport) {
      const data: any = {
        idCotizacion: this.lsInfoCotizacion?.idCotizacion
      }
      this.cotizacion.editCotizacion(this.token.token, data).subscribe({
        next: (response) => {
          window.location.reload();
          this.message.add({ severity: 'warning', detail: 'Favor seleccione una política comercial' })
        },
        error: (error: HttpErrorResponse) => {
          this.config.handleError(error);
        }
      })
    }
  }

  /// asignando flete personalizado
  setShippingValue = () => {
    const data = {
      idCotizacion: this.idCotizacion ?? 0,
      editedShippingValue: true,
      ShippingValue: this.shippingValue,
    }
    this.load = true;
    this.cobroFlete.subtotal = 0;
    this.cobroFlete.impuesto = 0;
    this.cotizacion.setCotizacionShippingValue(this.token.token, data).subscribe({
      next: (response) => {
        this.load = false;
        this.displayFlete = false;
        this.cobroFlete.subtotal = Number(((this.shippingValue / ((19 / 100) + 1))).toFixed(2));
        this.cobroFlete.impuesto = Number((this.shippingValue - this.cobroFlete.subtotal).toFixed(2));

      },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); this.load = false; }
    })
  }

  endQuotation = (option: number) => {
    if (this.emailShipping != "") {

      /*Envíar la información al cliente*/
      let detalil = this.lsInfoCotizacion.detalle.map((row: any) => {
        return {
          idCotizacion: this.lsInfoCotizacion?.idCotizacion ?? 0,
          idProducto: row.idProducto,
          cantidad: row.cantidad,
          subtotal: Number(((((row.precioPromocion < row.precio ? row.precioPromocion : row.precio)) / (((row.infoProducto.impuesto) / 100) + 1)) * row.cantidad).toFixed(2)),
          impuesto: Number((((row.precioPromocion < row.precio ? row.precioPromocion : row.precio) * row.cantidad)).toFixed(2)) -
            Number(((((row.precioPromocion < row.precio ? row.precioPromocion : row.precio)) / (((row.infoProducto.impuesto) / 100) + 1)) * row.cantidad).toFixed(2)),
          descuento: (row.precio * row.cantidad) - (row.precioPromocion * row.cantidad),
          porcentaje: (row.applyDiscount ?? false) ? row.discount : 0
        }
      })

      const data = {
        idCotizacion: this.lsInfoCotizacion?.idCotizacion ?? 0,
        estado: 2,
        correoNotificacion: this.emailShipping,
        idPoliticaComercial: this.selectedCommercialPolicy.idPoliticaComercial,
        detalleCotizacions: detalil,
        dataShipping: this.lsInfoCotizacion?.dataShipping
      }


      this.cotizacion.setEnviarCotizacion(this.token.token, data, option).subscribe({
        next: (response) => {
          this.msgTerminationQuotation = '<div class="p-message p-message-success p-3">Cotización enviada satisfactoriamente, el enlace es: <b>' + response as string + '</b></div>';
          this.lsInfoCotizacion.estado = 2;
          //Dejar copiado en el portapapeles
          if (option == 2)// option para enviar enlace
            navigator.clipboard.writeText(response as string);
          else {
            this.getReportQuotation();
            this.msgTerminationQuotation = '';
          }


          setTimeout(() => {
            this.divShowEndQuotation = false;
          }, 5000);
        },
        error: (error: HttpErrorResponse) => {
          this.msgTerminationQuotation = '<div class="p-message p-message-success p-3">Se ha presentado un error, favor intente nuevamente</div>';
          this.config.handleError(error);
        }
      })




    } else
      this.msgTerminationQuotation = '<div class="p-message p-message-error p-3">Favor ingrese el correo electrónico</div>'
  }

  returnHistory = () => {
    this.router.navigate(['cotizacion/crear_cotizacion'])
  }



  /**
   * 
   * @param item Linea a modificar el precio, acorde a lo expuesto en la caja de texto
   */
  openDialogCambioPrecio = (item: any, index: number) => {
    this.itemSKU = item?.infoProducto ?? "{}";
    this.itemSKU.index = index;
    this.displayPrecio = true;
  }

  /**
   * Se procede a la personalización de precio.
   */
  setCambioPrecio = () => {

    if (this.itemSKU.precioFinal > 0) {
      // activando la señal para saber que se aplico un descuento
      if (this.priceDiscountType == 2) {
        this.lsInfoCotizacion.detalle[this.itemSKU.index].applyDiscount = true;
        this.lsInfoCotizacion.detalle[this.itemSKU.index].discount = this.itemSKU.precioFinal;
      }

      this.lsInfoCotizacion.detalle[this.itemSKU.index].precioPromocionOld = this.lsInfoCotizacion.detalle[this.itemSKU.index].precioPromocion;
      this.lsInfoCotizacion.detalle[this.itemSKU.index].precioPromocion = this.priceDiscountType == 1 ? this.itemSKU.precioFinal : (this.lsInfoCotizacion.detalle[this.itemSKU.index].precioPromocion - (this.itemSKU.precioFinal * this.lsInfoCotizacion.detalle[this.itemSKU.index].precioPromocion) / 100);
      this.displayPrecio = false;
      this.getTotal()
      this.message.add({ severity: 'success', summary: 'Información', detail: 'Se aplico el ' + this.currency.transform(this.itemSKU.precioFinal) + ' al producto indicado' });
    }
    else
      this.message.add({ severity: 'warn', summary: 'Información', detail: 'El producto no puede registrar en precio cero' });
  }

  getReportQuotation = () => {
    this.load = true;
    this.reporte.getPDFCotizacion(this.idCotizacion ?? 0, 'pdf').subscribe({
      next: (response) => {
        this.urlDownload = this.config.urlService.toString() + (response as String);
        window.open(this.urlDownload, "_blank");
        this.load = false;
      }, error: (error: HttpErrorResponse) => {
        this.load = false;
        this.config.handleError(error);
        this.msgTerminationQuotation = '<div class="p-message p-message-info">Se ha presentado un error, favor intente de nuevo</div>';
      }
    })
  }

  /**
   * Obtener el flete, acorde a la ciudad seleccionada
   */
  getFlete = () => {
    if (!(this.lsInfoCotizacion?.editedShippingValue ?? false)) {
      this.load = true;
      this.cobroFlete.subtotal = 0;
      this.cobroFlete.impuesto = 0;
      // si la orden ha sido finalizada solo se importa la información que ya fue liquidada por el cliente
      if (this.lsInfoCotizacion.payment > 0) {
        this.cobroFlete.subtotal = Number(this.lsInfoCotizacion.flete.toFixed(2));
        this.cobroFlete.impuesto = Number(this.lsInfoCotizacion.fleteImpuesto.toFixed(2));
        //this.totales[1] = this.totales[1] + this.cobroFlete.impuesto;
        this.totales[2] = this.totales[2] + this.cobroFlete.subtotal + this.cobroFlete.impuesto;
        this.load = false;
      } else {
        this.load = false;
        this.cobroFlete.impuesto = 0;
        this.cobroFlete.subtotal = 0;
        //b s ii la orden ha sido exeptuada del ceobro de flete
        if (!(this.lsInfoCotizacion?.exemptShippingValue ?? true))
          this.flete.getFlete(this.lsInfoCotizacion.idCotizacion, this.cityShippingSelected.idCiudad, this.lsInfoCotizacion.estado == 1 ? 1 : 0).subscribe({
            next: (response) => {
              this.load = false;
              this.shippingValue = response as any;
              if ((this.shippingValue ?? 0) > 0) {
                // calculando valores
                this.cobroFlete.subtotal = Number(((this.shippingValue / ((19 / 100) + 1))).toFixed(2));
                this.cobroFlete.impuesto = Number((this.shippingValue - this.cobroFlete.subtotal).toFixed(2));

                this.totales[2] = this.totales[2] + this.cobroFlete.subtotal + this.cobroFlete.impuesto;
              }
            },
            error: (error: HttpErrorResponse) => { this.load = false; }
          })
      }
    } else {
      // información si viene editado el flete
      this.shippingValue = this.lsInfoCotizacion.shippingValue;
      this.cobroFlete.subtotal = Number(((this.shippingValue / ((19 / 100) + 1))).toFixed(2));
      this.cobroFlete.impuesto = Number((this.shippingValue - this.cobroFlete.subtotal).toFixed(2));
    }
  }
}
